let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3U29J")).then(() => parcelRequire('1OI2f'));